module.exports = __webpack_public_path__ + "media/images/logo-white-notext-6edbf18eea3402ab207313c1c2da3e30.png";